import basic from './version/basic';

export function basicVersion() {
  return basic;
}
